module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PW-79feea556f7e93e6a43af6f8d406471e.png";